import React from 'react';
import NextLink from 'next/link';
import classNames from 'classnames';
import * as PropTypes from 'prop-types';

import Helpers from '@utils/Helpers';

const Breadcrumbs = ({ list, className }) =>
  Helpers.arrayHasItems(list) && (
    <div className={classNames('breadcrumbs', className)}>
      <ul className="breadcrumbs__list">
        {list.map(item => {
          const label = item.cutLabel
            ? Helpers.cutString(item.label, item.cutLabel)
            : item.label;

          return (
            <li
              key={item.label}
              title={item.label}
              className="breadcrumbs__item"
            >
              {(item.href && (
                <NextLink href={item.href} as={item.as}>
                  <a className="breadcrumbs__link">{label}</a>
                </NextLink>
              )) ||
                label}
            </li>
          );
        })}
      </ul>
    </div>
  );

Breadcrumbs.propTypes = {
  list: PropTypes.array,
  className: PropTypes.string
};

export default Breadcrumbs;
